import React from 'react';
import { MapPin } from 'lucide-react';

const LiveMap = ({ latitude, longitude, address, city, className = "h-64 w-full" }) => {
  // Use coordinates if available, otherwise use address
  let mapUrl;
  
  if (latitude && longitude) {
    // Use GPS coordinates - Simple Google Maps embed URL
    mapUrl = `https://maps.google.com/maps?q=${latitude},${longitude}&hl=nl&z=15&output=embed`;
  } else if (address) {
    // Use address for map - Simple Google Maps embed URL
    const fullAddress = city ? `${address}, ${city}` : address;
    const encodedAddress = encodeURIComponent(fullAddress);
    mapUrl = `https://maps.google.com/maps?q=${encodedAddress}&hl=nl&z=15&output=embed`;
  } else {
    // No location data available
    return (
      <div className={`${className} bg-gray-200 rounded-lg flex items-center justify-center border border-gray-300`}>
        <div className="text-center">
          <MapPin className="w-12 h-12 text-gray-400 mx-auto mb-2" />
          <p className="text-gray-500 font-medium">Locatie niet beschikbaar</p>
          <p className="text-sm text-gray-400 mt-1">Geen adres of GPS coördinaten beschikbaar</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`${className} rounded-lg overflow-hidden border-2 border-gray-200 shadow-lg relative`}>
      <iframe
        src={mapUrl}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={`Kaart van ${address || city || 'Property'}`}
        className="w-full h-full"
      />
      {/* Overlay pin indicator */}
      <div className="absolute top-4 left-4 bg-white rounded-lg px-3 py-2 shadow-md flex items-center space-x-2 z-10">
        <MapPin className="w-5 h-5 text-blue-600" />
        <span className="text-sm font-medium text-gray-900">
          {address && city ? `${address}, ${city}` : address || city || 'Locatie'}
        </span>
      </div>
    </div>
  );
};

export default LiveMap;
